export default __webpack_public_path__ + "static/reel-531056691e54275c41d82d058d308e42.mp4";